<template>
    <div class="order-card">
        <div class="order" :class="[{'order-collapse': collapse}, `order-${color}`]">
            <div class="order-body order-body-collapse" @click="body_click">
                <div class="order-body-item" v-for="item, i in body_content" :key="i">
                    <div class="order-body-title">
                        {{ item.title }}
                    </div>
                    <div class="order-body-content">
                        {{ item.content }}
                    </div>
                </div>
            </div>
            <div class="order-course">
                <CourseCircle color="blue"/>
                <CourseCircle color="red"/>
                <CourseCircle color="yellow"/>
                <CourseCircle color="green"/>
                <CourseCircle color="white"/>
                <CourseCircle color="white"/>
                <CourseCircle color="white"/>
                <CourseCircle color="white"/>
            </div>
        </div>
    </div>
</template>
<script>
import CourseCircle from './CourseCircle.vue'
import tools from '@/sag-core/tools.js'
import { ref, reactive } from '@vue/composition-api'
export default {
    name: 'OrderCard',
    components: {
        CourseCircle
    },
    props: {
        color: {
            type: String,
            default: 'blue'
        },
        body_content: {
            type: Array,
            default: ()=>{return []}
        }
    },
    setup(props, ctx){
            
        const collapse = ref(false)

        const body_click = ()=>{
            tools.debug.log({tag: 'DEBUG', title: '點擊', content: 'body_click'})
            collapse.value = !collapse.value
        }

        return {
            body_click,
            collapse,
        }
    }
}
</script>
<style lang="scss">
@use "sass:map";
$card-color: (
    "blue": (
        #E7F8FF,
    ),
    "red": (
        #ff7300,
    ),
    "yellow": (
        #FFFB9F,
    ),
    "green": (
        #B9FFAD,
    ),
);
@each $name, $clr in $card-color {
    .order-#{$name} .order-body{
        background: $clr;
    }
};

.order-collapse {
    height: 330px !important;
    .order-body {
        height: 70%;
    }
}

.order {
    max-width: 350px;
    width: 100%;
    height: 210px;
    background: linear-gradient(180deg, #B0C4E1 60.94%, #b0c4e100 100%);
    border-radius: 10px;
    position: relative;
    transition: .3s;
}

.order-body {
    width: 95%;
    height: 60%;
    background: #E7F8FF;
    border-radius: 10px;
    position: absolute;
    left: 2.5%;
    top: 5%;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

    padding: 5px 7px 5px 7px;
    overflow: hidden;
    transition: .3s;
    
    .order-body-item {
        display: flex;
        height: 20px;
        .order-body-title .order-body-content {
            font-family: "微軟正黑體", "Montserrat";
            font-weight: bolder;
            font-size: 14px;
            line-height: 17px;
        }
    
        .order-body-title {
            margin-right: 14px;
        }
    }
}

.order-course {
    transition: .3s;
    width: 100%;
    display: flex;
    position: absolute;
    bottom: 15%;
    justify-content: space-between;
}

.order-course::after {
    content: '';
    background: black;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 95%;
    height: 2px;
    transform: translate(-50%, -50%);
    // border: 1px solid #000000;
    box-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.25);
    filter: blur(0.25px);
}

</style>